/** Angular Imports */
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BnNgIdleService } from 'bn-ng-idle'; // import bn-ng-idle service
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

/** Tanslation Imports */
import { TranslateModule } from '@ngx-translate/core';

/** Environment Configuration */
import { environment } from 'environments/environment';

/** Main Component */
import { WebAppComponent } from './web-app.component';

/** Not Found Component */
import { NotFoundComponent } from './not-found/not-found.component';

/** Custom Modules */
import { CoreModule } from './core/core.module';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { SettingsModule } from './settings/settings.module';
import { SelfServiceModule } from './self-service/self-service.module';
import { ProfileModule } from './profile/profile.module';
import { ForexTransactionsModule } from './forex-transactions/forex-transactions.module';
import { AllocateCashModule } from './vault-transactions/allocate-cash/allocate-cash.module';
import { SettleCashModule } from './vault-transactions/settle-cash/settle-cash.module';
import { CashDifferenceModule } from './cash-difference/cash-difference.module';
import { TellerReportsModule } from './teller-reports/teller-reports.module';
import { CashierTransactionsModule } from './cashier-transactions/cashier-transactions.module';

/** Main Routing Module */
import { AppRoutingModule } from './app-routing.module';
import { SavingsTransactionsModule } from './savings-transactions/savings-transactions.module';
import { ClientModule } from './client/client.module';
import { TellerGlobalServiceService } from './shared/teller-data/teller-global-service.service';
import { LoanTransactionsModule } from './loan-transactions/loan-transactions.module';
import { ApprovalModule } from './approval/approval.module';


/** Material table */
import { MatTableModule } from '@angular/material/table';
import { CotizacionesModule } from './cotizaciones/cotizaciones.module';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { IngresosEgresosVariosModule } from './ingresos-egresos-varios/ingresos-egresos-varios.module';
/**
 * App Module
 *
 * Core module and all feature modules should be imported here in proper order.
 */
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HammerModule,
    HttpClientModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    TranslateModule.forRoot(),
    CoreModule,
    HomeModule,
    LoginModule,
    ProfileModule,
    ForexTransactionsModule,
    AllocateCashModule,
    SettleCashModule,
    SettingsModule,
    SelfServiceModule,
    SavingsTransactionsModule,    
    ClientModule,
    IngresosEgresosVariosModule,
    LoanTransactionsModule,
    CashDifferenceModule,
    CashierTransactionsModule,
    TellerReportsModule,
    CotizacionesModule,
    AppRoutingModule,
    ApprovalModule,
    MatTableModule,
  ],
  declarations: [WebAppComponent, NotFoundComponent],
  providers: [BnNgIdleService, {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [WebAppComponent,[TellerGlobalServiceService]]
})
export class AppModule { }
